import { render, staticRenderFns } from "./videoPlayBox.vue?vue&type=template&id=c4659228&scoped=true"
import script from "./videoPlayBox.vue?vue&type=script&lang=js"
export * from "./videoPlayBox.vue?vue&type=script&lang=js"
import style0 from "./videoPlayBox.vue?vue&type=style&index=0&id=c4659228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4659228",
  null
  
)

export default component.exports